export default "__VITE_ASSET__C5$o3Z5u__"